// Google Analytics 4 — loaded only after user consents to statistics cookies.
// Tracking ID: G-PLJ5LJ0J4F  (MM Byggeri — mmbr.dk)

export const GA_MEASUREMENT_ID = "G-PLJ5LJ0J4F";
export const CONSENT_STORAGE_KEY = "mmbr-cookie-consent";

let gaLoaded = false;

/** Read consent object from localStorage. */
export const getConsent = () => {
    try {
        const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (_) {
        return null;
    }
};

/** Persist consent object. */
export const setConsent = (consent) => {
    try {
        localStorage.setItem(
            CONSENT_STORAGE_KEY,
            JSON.stringify({ ...consent, timestamp: Date.now() }),
        );
    } catch (_) {
        /* ignore storage errors */
    }
};

/** Inject GA4 script + initialize gtag. Idempotent. */
export const loadGA = () => {
    if (gaLoaded) return;
    if (typeof window === "undefined") return;

    // 1. Inject gtag.js
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    // 2. Bootstrap dataLayer + gtag stub
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
        anonymize_ip: true,
        send_page_view: false, // we send manually on route change
    });

    gaLoaded = true;
};

/** Send a manual page_view (used on route change). */
export const trackPageview = (pathname) => {
    if (!gaLoaded || typeof window === "undefined" || !window.gtag) return;
    window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: document.title,
    });
};

/** Returns true if the user has accepted statistics cookies. */
export const hasStatisticsConsent = () => {
    const c = getConsent();
    return !!(c && c.statistics);
};
